import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { rootUrl } from "../actions/constants";
const initialState = {
  browse: [],
  parentlov: []
};

const unregisteredInstState = state => state.unregisteredInst;

export const unregisteredInstSelector = createSelector(
  [unregisteredInstState],
  (unregisteredInstState) => unregisteredInstState.browse
);

export const parentlovSelector = createSelector(
  [unregisteredInstState],
  (unregisteredInstState) => unregisteredInstState.parentlov
);

export const fetchUnregisteredInst = createAsyncThunk(
  "unregisteredinst/browse",
  async (arg, { rejectWithValue }) => {
    const postBody = {
      "first": 0,
      "isMetaRequired": true,
      "sort": [
        {
          "field": "name",
          "value": "asc"
        }
      ]
    };
    try {
      const response = await makeAjaxRequest.postWithAuth(`${rootUrl}/admin/unregistered/sites/browse`, postBody);
      const { data } = response;
      if (arg && arg.ctepId) {
        const index = data.findIndex(item => item.ctepId === arg.ctepId);
        if (index > -1) {
          const [itemWithKey] = data.splice(index, 1);
          data.unshift(itemWithKey);
        }
      }
      const d = response.data || [];
      return d;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchParentLov = createAsyncThunk(
  "unregisteredinst/parentlov",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.fetchWithAuth(`${rootUrl}/admin/unregistered/sites/parentlov`);
      const d = response?.map((item) => ({
        ...item,
        label: `${item.ctepId} | ${item.name} | ${item.ognType}`,
        value: item.id
      })) || [];
      return d;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const unregisteredInstSlice = createSlice({
  name: "unregisteredInst",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUnregisteredInst.fulfilled, (state, action) => {
      state.browse = action.payload;
    });
    builder.addCase(fetchParentLov.fulfilled, (state, action) => {
      state.parentlov = action.payload;
    });
  }
});
export default unregisteredInstSlice.reducer;
